import React from 'react';
import MultiLangText from '../multilang/MultiLangText'
import Moment from 'react-moment'
import VideoPlayer from '../video/VideoPlayer'
import NavLink from '../router/NavLink'

import {TimelineMax,TweenMax, Power2, Power3, Power4 ,Back, Circ} from 'gsap'
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';
import SplitText from 'gsap/SplitText';

class NewsItem extends React.Component {


  constructor(){
    super();

    this.state = {
      openArticle_tl:null,
      closing:false
    }

    this.expand = this.expand.bind(this)
    this.contract = this.contract.bind(this)
    this.animateIn = this.animateIn.bind(this)
  }


  animateIn(){
    //console.log("Let's do this!!!");


    // clear height
    this.refs.item.setAttribute('style','')

    let animateIn_tl = new TimelineMax()
        animateIn_tl.from(this.refs.item,.8,{height:0,opacity:0})
        animateIn_tl.add(()=>{
            this.refs.item.setAttribute('style','')
        })

        //animateIn_tl.pause();


  }


  componentDidMount(){

    // trigger animation if there isn't an image to load
    // hide until it's ready
    TweenMax.set(this.refs.item,{height:0})

    if(this.props.content.acf.header_image){
      if( this.props.content.acf.header_image[0].acf_fc_layout==="video"){
          this.animateIn();
      }
    }else{
      this.animateIn();

    }



  }

  componentWillUnmount(){
    (this.state.openArticle_tl)?
      this.state.openArticle_tl.kill()
    : null
  }

  contract(){
      this.setState({closing:true})
        this.state.openArticle_tl.timeScale(3)
      this.state.openArticle_tl.reverse();
  }

  expand(){
    //console.log("news item",this);
    this.refs.item.classList.toggle('open')

    //console.log("innerArticle",this.refs.innerArticle.offsetHeight);

    let innerHeight = this.refs.innerArticle.offsetHeight;
    let innerArticle = this.refs.innerArticle
    let copyCover = this.refs.gradient

    let openArticle_tl = new TimelineMax()

        openArticle_tl.add(()=>{
          if(this.state.closing==true){
            this.refs.item.classList.remove('open')
            innerArticle.setAttribute('style','')
            this.state.openArticle_tl.kill()
            this.setState({closing:false})

          }
        })
        //openArticle_tl.fromTo(innerArticle,1,{height:25},{height:innerHeight})
        openArticle_tl.fromTo(innerArticle,1,{height:0},{height:innerHeight})

        openArticle_tl.fromTo(copyCover,2,{top:'-100%'},{top:'100%'},'-=1')
        openArticle_tl.fromTo(this.refs.line1,.5,{width:0},{width:16},'-=.5')
        openArticle_tl.fromTo(this.refs.line2,.5,{width:0},{width:16},'-=.5')

        // clear style

        openArticle_tl.add(()=>{
          innerArticle.setAttribute('style','')
        })

    //window.location.pathname ='/news/'+this.props.content.id

    this.setState({openArticle_tl})

  }

  render(){



    let imageUrl = ''
    let videoItem;
    let hasHeader = false, hasVideoHeader = false, hasImageHeader = false;

    const content = this.props.content;

    //console.log("NewsItem",content);

    let titleObj =  {en:content.title.rendered};

    let shareTitle = 'Kastner News | '+titleObj.en
    let shareLink  = window.location.protocol +'//'+window.location.hostname +'/news/'+content.slug

    if(content.acf.title_with_breaks){

      for(let i in content.acf.title_with_breaks){
        if(content.acf.title_with_breaks[i]){

            titleObj = content.acf.title_with_breaks
            //console.log("Found a title",titleObj);
        }
      }

    }



    if(content.acf.header_image){

      // image
      if(content.acf.header_image[0].acf_fc_layout==="image"){
          imageUrl = content.acf.header_image[0].image.url;
          //console.log('imageUrl',imageUrl);
          hasHeader = true;
          hasImageHeader = true
      }

      // video
      if(content.acf.header_image[0].acf_fc_layout==="video"){
          //imageUrl = content.acf.header_image[0].image.url;
          //console.log('video ',content.acf.header_image[0]);
            videoItem = content.acf.header_image[0]
          hasHeader = true;
          hasVideoHeader = true;
      }
    }


    return (<div className={"news-item "+('newsid-'+this.props.content.id)} ref="item">
          <div className="news-header">
              {(hasHeader)?
                (hasImageHeader)?
                  <img src={imageUrl} onLoad={this.animateIn} />
                  :
                  <div><VideoPlayer className="content-row"  {...videoItem}  /></div>
                : null
            }
          </div>
          <div className="text">
          <div className="date">
            <Moment format="DD">{content.date}</Moment><span className="light"> / </span><Moment format="MM">{content.date}</Moment><span className="light"> / </span><Moment format="YY">{content.date}</Moment>
         </div>
              <h4><MultiLangText text={titleObj} /></h4>
              <div className="article-text">
                <div ref="innerArticle" className="inner-article">
                  <MultiLangText text={content.acf.article_text} />

                  {(content.acf.link_label && content.acf.link)?
                    <div className="article-link">
                      <NavLink to={content.acf.link} target={(!content.acf.open_in_new_window)? '_self' : '_blank'} ><strong><MultiLangText text={content.acf.link_label} /></strong></NavLink>
                    </div>
                  : null }
                  <div className="cover">
                    <div ref="gradient" className="gradient" />
                  </div>
                  <div className="share-icons">
                        <a href={"https://twitter.com/intent/tweet?text="+encodeURI(shareTitle)+" "+shareLink} target="_blank" className="icon twitter"></a>
                        <a href={"https://www.linkedin.com/shareArticle?mini=true&url="+shareLink+"&title="+encodeURI(shareTitle)} target="_blank" className="icon linkedin"></a>
                        <a href={"https://www.facebook.com/sharer/sharer.php?u="+shareLink} target="_blank" className="icon facebook"></a>
                        <a href={'mailto:?subject='+shareTitle+'&body='+shareLink}  className="icon email"></a>
                  </div>
                </div>
                <div className="close-button" ref="closeButton" onClick={this.contract}>
                  <div className="close-line" ref="line1" />
                  <div className="close-line" ref="line2"  />
                </div>
              </div>
              <NavLink to={'/news/'+this.props.content.slug} className="read-more-link" onClick={this.expand}>&lt; <MultiLangText text={this.props.optionsData.data.read_more} /> &gt;</NavLink>
          </div>

        </div>)
  }

}

export default NewsItem



// WEBPACK FOOTER //
// ./src/modules/news/NewsItem.js